'use strict';

module.exports = function (column) {
  var c = this.opts.columnsClasses;

  return c.hasOwnProperty(column) ? c[column] : '';
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/column-class.js